module.exports = __webpack_public_path__ + "static/media/team2.5d302750.jpg";